export class CreateBrokerageConfigRequest {
  BrokerageID: number;
  ConfigName: string;
  ConfigValue: string;
}
